/**
 * 商户在库记录
 */
import React from "react";
import { Button, Row, Col, Tooltip, Select, Input,Progress, Tag } from "antd";
import PageLayout from "../../ui/PageLayout";
import MemberParkDetial from "./MemberParkDetail";
import AddMemberParkInfo from "./AddMemberParkInfo";
import { fixedNumber } from '../../../util/util';
import http from '../../../axios/http';
import { global_data } from '../../ui/auth'

class SocialParkLog extends React.Component {
  columns = [
    {
      title: "商户号",
      dataIndex: "memberCode",
      width: "20%",
    },
    {
      title: "商户名",
      dataIndex: "memberName",
      width: "30%",
    },
    {
      title: "启用限制",
      dataIndex: "isControl",
      width: "10%",
      format: { false: "否", true: "是" },
    },
    {
      title: "已停数量",
      dataIndex: "count",
      width: "10%",
    },
    {
      title: "可停数量",
      dataIndex: "limit",
      width: "10%",
    },
    {
      title: "操作",
      render: (text, record, index) => (
        <div>
          <Tooltip title="查看正在库车辆">
            <Button type="primary" onClick={this.showDetail.bind(this, record)}>
              详情
            </Button>
          </Tooltip>
          &nbsp;&nbsp;
          {global_data.authCode.includes("BARRIER_MEMBER_PARK_ADD")?
          <Tooltip title="新增正在库车辆">
            <Button onClick={this.addParkInfo.bind(this, record)}>新增</Button>
          </Tooltip>
          :""}
        </div>
      ),
    },
  ];

  state = {
    loadData: "",
    queryData: {
      zone: "bizMall",
      memberName: "",
    },
    visible: false,
    addVisible: false,
    currentCarNum:0,
    totalCarNum:1000
  };
  componentDidMount() {
    this.calPercentage();
  }

  calPercentage(){
    let queryData = this.state.queryData;
    http.post({
      url: '/barrier/vehicleParkInfo/numMemberPark',
      data: queryData,
      success: (res) => {
        if(res.content){
          let current=0;
          let total=0;
          for (let i = 0; i < res.content.length; i++) {
            // if(res.content[i].memberCode==='91350200260066698P'
            // ||res.content[i].memberCode==='91350211MA8UQUUA5Y'){
            //   continue;
            // }
            current+=res.content[i].count
            total+=res.content[i].limit
          }
          this.setState({ currentCarNum: current });
          this.setState({ totalCarNum: total });
        }
      },
    });
  }

  zoneChange = (val) => {
    console.log("zoneChange", val);
    let queryData = this.state.queryData;
    queryData["zone"] = val;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
    this.calPercentage();
  };

  refreshData = () => {
    let queryData = this.state.queryData;
    this.state.loadData(queryData);
    this.calPercentage();
  };

  hideModal = () => {
    this.setState({ visible: false });
    this.refreshData();
    this.calPercentage();
  };

  hideAddModal = () => {
    this.setState({ addVisible: false });
    this.refreshData();
    this.calPercentage();
  };

  showDetail = (record, e) => {
    console.log(record);
    this.setState({
      visible: true,
      detailMemberCode: record.memberCode,
      detailMemberName: record.memberName,
    });
  };
  addParkInfo = (record, e) => {
    console.log(record);
    this.setState({
      addVisible: true,
      detailMemberCode: record.memberCode,
      detailMemberName: record.memberName,
    });
  };
  memberSearch = (val) => {
    let queryData = this.state.queryData;
    queryData["memberName"] = val;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
    this.calPercentage();
  };
  
  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={6} style={{ paddingRight: "10px" }}>
                <Select
                  value={this.state.queryData.zone}
                  onChange={this.zoneChange}
                  style={{ width: "100%" }}
                >
                  <Select.Option value="bizMall">交易市场</Select.Option>
                  <Select.Option value="bizThreeTenant">3号地块</Select.Option>
                </Select>
              </Col>
              <Col span={6} style={{ paddingRight: "10px" }}>
                <Input.Search
                  placeholder="输入商户名称过滤"
                  onSearch={this.memberSearch.bind(this)}
                ></Input.Search>
              </Col>
              <Col span={3}>
                <Button onClick={this.refreshData.bind(this)}>刷新</Button>
              </Col>
              <Col span={3}>
                  <Tag>{this.state.currentCarNum}/{this.state.totalCarNum}（当前停车数/总停车数）</Tag>
                  <Progress percent={fixedNumber((this.state.currentCarNum / this.state.totalCarNum * 100).toFixed(2), 2)} />
              </Col>
            </Row>
          }
          rowKey="memberCode"
          url="/barrier/vehicleParkInfo/numMemberPark"
          columns={this.columns}
          initParams={this.state.queryData}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <MemberParkDetial
          visible={this.state.visible}
          memberCode={this.state.detailMemberCode}
          memberName={this.state.detailMemberName}
          zone={this.state.queryData.zone}
          onCancel={this.hideModal.bind(this)}
        />
        <AddMemberParkInfo
          visible={this.state.addVisible}
          memberCode={this.state.detailMemberCode}
          memberName={this.state.detailMemberName}
          zone={this.state.queryData.zone}
          onCancel={this.hideAddModal.bind(this)}
        />
      </div>
    );
  }
}

export default SocialParkLog;
